import React, { useState, useRef, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { InputField } from '../../../../../components/formFields/InputField';
import Label from '@/components/Label';
import { AreaField } from '../../../../../components/formFields/AreaField';
import { SelectFormField } from '../../../../../components/formFields/SelectFormField';
import { apiService } from '../../../../../utils/api';

type ProfessionBondModalProps = {
  visible: boolean;
  title: string;
  formProps?: any;
  onSubmit: (id: any, values: any) => void;
  onClose: () => void;
};

const ProfessionBondModal = ({
  visible,
  title,
  formProps,
  onSubmit,
  onClose,
}: ProfessionBondModalProps) => {
  const ValidationSchema = Yup.object().shape({
    title: Yup.string().nullable().required('Povinné pole'),
    description: Yup.string().nullable().required('Povinné pole'),
    professionId: Yup.string().nullable().required('Povinné pole'),
  });

  const formRef = useRef<any>(null);
  const [professions, setProfessions] = useState<any[]>([]);

  useEffect(() => {
    const fetchProfessions = async () => {
      try {
        const data = (await apiService.get('/api/v1/profession-bond/dropdown/?pagination=false'))
          .data;
        setProfessions(data);
      } catch {
        //
      }
    };

    fetchProfessions();
  }, []);

  const onSubmitButton = () => {
    if (!formRef?.current) return null;
    formRef.current.submitForm();
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Formik
            innerRef={formRef}
            enableReinitialize={true}
            validationSchema={ValidationSchema}
            initialValues={{
              title: formProps?.title || null,
              description: formProps?.description || null,
              professionId: formProps?.profession?.id || null,
            }}
            onSubmit={(values) => {
              onSubmit(formProps?.id, {
                ...values,
                profession: values.professionId,
              });
            }}
          >
            {(props) => {
              const { values } = props;
              return (
                <>
                  <Form>
                    <div className="space-y-1">
                      <div>
                        <Label name="title" title="Název" required />
                        <Field
                          name="title"
                          value={values.title || null}
                          placeholder="Název"
                          component={InputField}
                          data-testid="profession-bond-modal-title-input"
                        />
                      </div>

                      <div>
                        <Label name="description" title="Popisek" required />
                        <Field
                          name="description"
                          value={values.description || null}
                          placeholder="Popisek"
                          component={AreaField}
                          data-testid="profession-bond-modal-description-input"
                        />
                      </div>

                      <div>
                        <Label name="profession" title="Profese" required />
                        <SelectFormField
                          name="professionId"
                          data={professions || []}
                          placeholder="Profese"
                          data-testid="profession-bond-modal-profession-select"
                        />
                      </div>
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            onClick={() => onClose()}
            data-testid="profession-bond-modal-close-btn"
          >
            Zavřít
          </Button>
          <Button
            key={2}
            onClick={() => onSubmitButton()}
            data-testid="profession-bond-modal-submit-btn"
          >
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ProfessionBondModal;
